import { TreeLegend } from './types'

type TreeNavigatorLegendProps = {
  legend?: TreeLegend[]
  width: number
}

export function TreeNavigatorLegend({ legend, width }: TreeNavigatorLegendProps) {
  if (!legend?.length) return null

  return (
    <div
      style={{ width, maxWidth: 450 }}
      className="bg-offwhite absolute bottom-0 left-0 flex flex-wrap gap-3 rounded-md p-3"
    >
      {legend.map((item) => (
        <div key={item.label} className="flex items-center gap-1">
          <div className="h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
          <span className="text-xs font-medium">{item.label}</span>
        </div>
      ))}
    </div>
  )
}
